export const hasProtocol = (url: string): boolean => {
  const protocolRegex = /^(http:\/\/|https:\/\/)/;
  return protocolRegex.test(url);
};
